<template lang="html">

  <button class="fav" :style="styles.colorBasic" @click="toggleFavoritos(data)" :on="favoritos.some(e=>e.idPractica == data[id])">

    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 508.488 508.488" style="enable-background:new 0 0 508.488 508.488;" xml:space="preserve">
    <g>
      <g>
        <g>
          <path d="M386.284,282.387c-12.999-14.779-35.755-22.947-52.568-27.174V90.58
          c16.622-5.626,30.734-12.681,41.889-20.913c9.535-7.024,14.334-18.815,12.522-30.511c-1.843-11.696-9.98-21.421-21.294-25.204
          C351.387,8.74,316.013,0,254.26,0c-65.313,0-101.386,10.075-113.877,14.397c-11.092,3.846-19.165,13.508-20.976,25.108
          c-1.812,11.569,2.924,23.233,12.3,30.32c11.315,8.486,25.776,15.669,43.065,21.326h0.032v164.061
          c-16.781,4.227-39.569,12.395-52.6,27.174c-6.77,7.691-9.408,18.18-7.119,28.159c2.288,9.948,9.28,18.211,18.72,22.184
          c22.566,9.471,60.927,15.383,104.596,16.59l-0.064,0.254v95.347c0,17.544,7.119,63.565,15.891,63.565
          c8.74,0,15.891-46.021,15.891-63.565v-95.347l-0.032-0.254c43.669-1.176,82.031-7.215,104.596-16.622
          c9.439-3.909,16.463-12.204,18.72-22.152C395.692,300.535,393.054,290.047,386.284,282.387z M254.228,317.793
          c-57.717,0-93.472-8.263-108.188-14.397c5.721-6.484,19.006-12.967,36.55-17.417l23.964-6.039V68.078l-21.898-7.151
          c-16.59-5.435-27.365-11.632-33.88-16.559c16.908-5.848,51.138-12.618,103.452-12.618c51.265,0,85.336,6.515,102.53,12.3
          c-6.706,4.958-17.449,11.029-33.213,16.4l-21.644,7.31v212.18l23.964,6.039c17.608,4.45,30.893,10.933,36.55,17.417
          C347.732,309.53,311.977,317.793,254.228,317.793z"/>
        </g>
      </g>
    </g>
  </svg>

</button>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  export default  {
    name: 'fav',
    props: ['data'],
    methods: {
      ...mapActions(['toggleFavoritos'])
    },
    computed: {
      ...mapGetters({
        styles : 'getStyles',
        colors : 'basicColors',
        favoritos : 'getFavoritos'
      }),
      id(){
        let id = (!!this.data.idPractica) ? 'idPractica' : 'urlAcceso';
        return id;
      }
    }
  }
</script>

<style scoped lang="scss">
.fav{
  width: 25px;
  height: 25px;
  display: inline-block;
  border:1px solid #9b9b9b;
  border-radius: 50%;
  background: none;
  position: relative;
  margin-left: 8px;
  overflow: hidden;
  background: transparent;
  cursor: pointer;
  outline: none;
  

  svg{
    height: 18px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 2px;
    transition: .5s;
    transition-timing-function: ease-in-out;

    path{
      fill:#9b9b9b;
    }
  }

  &[on=true]{
    background: currentColor;
    border-color: currentColor;
    svg{
      transform: translateY(8px) translateX(-50%); 
      path{
        fill:#fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/fav.vue